export default __webpack_public_path__ + "static/own-listing-page-beba40c274ca5a736cd940a6f1dd3ac7.png";